module.exports = __webpack_public_path__ + "04d7bf44735425feeae95497cf4019b6.svg";